import * as React from 'react';

import Tooltip from 'components/Tooltip';

import { abbrNum } from 'utils/helper/common';
import { t } from 'utils/language';

import type { IntersectionChartItem, StatisticsCommon } from 'types';

const MSG_KEY = 'lists_stats.audience_overlap.customizable_overlap.legends';
const item1Color = 'rgba(0, 124, 219, 0.7)';
const item2Color = 'rgba(0, 207, 215, 0.8)';
const overlapColor = '#268bc8';
const zeroItem = {
  absolute: 0,
  percentage: 0,
  label: '',
  name: ''
};

function getIntersectionItem(
  item: StatisticsCommon,
  color: string,
  key?: string,
  overlap: StatisticsCommon = zeroItem
): IntersectionChartItem {
  const label: string | undefined = t(`${key}.label`);

  const intersectionItem = {
    label,
    value: item.absolute + overlap.absolute,
    color,
    percentage: item.percentage + overlap.percentage
  };

  if (!label) {
    return {
      ...intersectionItem,
      percentage: String(intersectionItem.percentage)
    };
  }

  const legend = {
    color,
    formatter: () => (
      <React.Fragment>
        <span>
          {label}: <strong>{abbrNum(item.absolute)}</strong> ({item.percentage.toFixed(0)}%)
        </span>
        &nbsp;
        <Tooltip
          display="flex"
          width="long"
          message={t(`${key}.tooltip`)}
          showQuestionMark
        />
      </React.Fragment>
    )
  };

  return {
    ...intersectionItem,
    percentage: String(intersectionItem.percentage),
    legend
  };
}

export const getCustomizableAudienceOverlapData = (item1: StatisticsCommon, item2: StatisticsCommon, overlap: StatisticsCommon) => ({
  item1: getIntersectionItem(item1, item1Color, `${MSG_KEY}.unique`, overlap),
  item2: getIntersectionItem(item2, item2Color, undefined, overlap),
  overlap: getIntersectionItem(overlap, overlapColor, `${MSG_KEY}.overlap`)
});
